import ControlBatchReport from './ControlBatchReport'
import { GlobalController } from 'src/shared/global/GlobalController'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'control-batch-report',
    name: 'controlBatchReport',
    component: ControlBatchReport,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
